<div class="flex flex-row justify-between pb-10">
  <div class="flex flex-col">
    <div class="mat-headline-5 mb-6 fw-700 m-0">{{ title }}</div>
    <div class="mat-body-1 fw-500 m-0">{{ subtitle }}</div>
  </div>
  <mat-icon svgIcon="close" class="close-icon" (click)="sidenavService.closeRightSidenav()"></mat-icon>
</div>

<mat-divider class="mb-20 neutral-2"></mat-divider>
